import { DeepPartial } from 'react-hook-form';
import { AdditionalInterestAndInsured } from 'src/configs/APISchemas/Application.schema';

export function isAdditinalInsuredSwitchEnabled(
  additionalInsured: DeepPartial<AdditionalInterestAndInsured[]> | undefined,
) {
  if (!additionalInsured || additionalInsured.length === 0) {
    return false;
  }

  return additionalInsured.every((insured) => {
    if (!insured) {
      return false;
    }

    return insured.email && insured.firstName && insured.lastName;
  });
}
